import { c as _c } from "react/compiler-runtime";
import { useQuery } from '@tanstack/react-query';
import { JsonObject } from 'shared/type';
import { compactObj } from 'shared/collection';
import { Database, sb, Tables } from 'utils/db';
import { SupabaseClient } from '@supabase/supabase-js';
import { pipe } from 'remeda';
import type { MyProfile } from './profileTypes';
import { ActivityCfg, zActivityRow } from './activityTypes';
export const saveActivity = async ({
  sb,
  activity,
  profile,
  created_at
}: {
  sb: SupabaseClient<Database>;
  activity: ActivityCfg;
  profile: MyProfile;
  created_at?: string;
}) => {
  const {
    workspace_id,
    id: profile_id
  } = profile;
  const {
    error
  } = await sb.from('activity').insert(compactObj({
    cfg: activity as JsonObject,
    workspace_id,
    profile_id,
    created_at
  }) as Tables['activity']['Insert']);
  if (error) console.error('error saving activity', error);
};
export const useLatestActivity = t0 => {
  const $ = _c(10);
  const {
    workspace_id,
    question_id,
    type,
    before
  } = t0;
  let t1;
  if ($[0] !== question_id) {
    t1 = ["activity-my", question_id];
    $[0] = question_id;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== before || $[3] !== question_id || $[4] !== type || $[5] !== workspace_id) {
    t2 = async () => await pipe(sb.from("activity_my").select("cfg, created_at").match(compactObj({
      workspace_id,
      question_id,
      type
    })), q => before ? q.lt("created_at", before) : q, _temp2);
    $[2] = before;
    $[3] = question_id;
    $[4] = type;
    $[5] = workspace_id;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  let t3;
  if ($[7] !== t1 || $[8] !== t2) {
    t3 = {
      queryKey: t1,
      queryFn: t2
    };
    $[7] = t1;
    $[8] = t2;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  const query = useQuery(t3);
  return query;
};
function _temp(r) {
  if (r.error) {
    throw r.error;
  }
  return zActivityRow.pick({
    created_at: true,
    cfg: true
  }).parse(r.data);
}
function _temp2(q_0) {
  return q_0.order("created_at", {
    ascending: false
  }).limit(1).maybeSingle().then(_temp);
}